import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
// import SVG from 'react-inlinesvg';

const SingleServices = () => {
    const [services, setServices] = useState([]);

    // eslint-disable-next-line no-undef
    let { bookingParkId, language, apiBaseUrl } = pluginGlobals;
    const parksApiBase = `${apiBaseUrl || 'https://api.bestpark.com'}/parks`;

    // eslint-disable-next-line no-undef
    if (!bookingParkId && bookingPageSelectedPark && bookingPageSelectedPark > 0) {
        // eslint-disable-next-line no-undef
        bookingParkId = bookingPageSelectedPark;
    }

    useEffect(() => {
        if (!bookingParkId || !language) return;

        axios.get(`${parksApiBase}/${bookingParkId}/amenities?lang=${language}`)
            .then((response) => {
                setServices(response.data);
            });
    },[bookingParkId, language, parksApiBase]);

    // <SVG src={`https://uploads.bestpark.com/uploads/amenities/${service.icon}`} width={24} height="auto" title="Menu" />

    return (
        <div>
            <ul className="park-services__list">
                {services && services.map(service => {
                    return (
                        <li>
                            <span>
                                <img src={`https://uploads.bestpark.com/uploads/amenities/${service.icon}`} alt=""/>
                            </span>
                            {service.name}
                        </li>
                    )
                })}
            </ul>
        </div>);
}

export default SingleServices;
